<template>
  <div class="c-route-graph">
    <slot/>
    <div
      class="c-route-graph__current"
      :style="{
        'left': currentPosition + '%'
      }"
      v-if="currentPosition"
    >
      <div class="c-route-graph__current-dot"/>
      <div class="c-route-graph__current-ripple"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ORouteGraph',
  props: {
    currentPosition: {
      type: Number,
      default: null
    }
  }
}
</script>

<style lang="scss">
.c-route-graph {
  display: flex;
  position: relative;
}

@keyframes rippleRoute {
  0% {
    opacity: 0.5;
    transform: scale(0.9);
  }
  100% {
    opacity: 0;
    transform: scale(2);
  }
}

.c-route-graph__current {
  flex: none;
  height: 1.2rem;
  position: absolute;
  top: 0.6rem;
  width: 1.2rem;
}

.c-route-graph__current-dot {
  background-color: $primary-color;
  background-color: var(--primary-color);
  border: 0.2rem solid #fff;
  border-radius: 50%;
  bottom: 0;
  box-shadow: 0 0.2rem 1rem 0 rgba(#000, 0.3);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 2;
}

.c-route-graph__current-ripple {
  animation: rippleRoute 2s ease-out infinite both;
  background: $blue;
  border-radius: 50%;
  bottom: 0;
  left: 0;
  opacity: 0.5;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}
</style>
